import "./newMarket.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { DriveFolderUploadOutlined as UploadIcon } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";

const NewMarket = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Initialize navigate

  const { state } = useLocation(); // Access state passed from navigate
  const productData = state?.product || {}; // Extract product data or use an empty object

  // populate formData with productData if editing
  const [formData, setFormData] = useState({
    userId: productData.userId || userIdRedux,
    productName: productData.productName || "",
    productType: productData.productType || "Vegetables",
    productPrice: productData.productPrice || "",
    productUnitType: productData.productUnitType || "",
    productAddress: productData.productAddress || "",
    productStatus: productData.productStatus || "Available",
    productPhone: productData.productPhone || "",
    productEmail: productData.productEmail || "",
    productDescription: productData.productDescription || "",
    productImages: productData.productImages || [],
  });

  const [productImages, setProductImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const validateForm = () => {
    const errors = {};

    if (!formData.productName) errors.productName = "Product is required.";
    if (!/^[a-zA-Z\s]+$/.test(formData.productName))
      errors.productName = "Product name must be a string.";

    // if (!formData.productType) errors.productType = "Product Type is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.productType))
    //   errors.productType = "Product Type must be a string.";

    if (!formData.productPrice)
      errors.productPrice = "Product Price is required.";
    if (!formData.productUnitType)
      errors.productUnitType = "Product Unit is required.";
    if (!formData.productAddress)
      errors.productAddress = "Product Address is required.";
    if (!formData.productStatus)
      errors.productStatus = "Product Status is required.";

    if (!formData.productPhone)
      errors.productPhone = "Phone number is required.";
    if (!/^\d{10}$/.test(formData.productPhone))
      errors.productPhone = "Phone number must be 10 digits.";

    if (!formData.productEmail) errors.productEmail = "Email is required.";
    if (!/\S+@\S+\.\S+/.test(formData.productEmail))
      errors.productEmail = "Email format is invalid.";

    if (!formData.productDescription)
      errors.productDescription = "Product Description is required.";

    if (productImages.length === 0)
      errors.productImages = "exactly 3 Product images are required.";
    if (productImages.length > 3)
      // Changed from 0 to 3
      errors.productImages = "Select Not more than 3 Product images.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const validImages = files.filter((file) => {
      if (!file.type.startsWith("image/")) {
        alert(`File "${file.name}" is not a valid image.`);
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert(`File "${file.name}" exceeds the 5MB size limit.`);
        return false;
      }
      return true;
    });

    if (validImages.length > 0) {
      setFormData({ ...formData, productImages: validImages });

      // Generate image previews
      const previews = validImages.map((file) => URL.createObjectURL(file));
      setProductImages(previews);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setBackEndError("");

    const formDataToSubmit = new FormData();

    formDataToSubmit.append("userId", formData.userId);
    formDataToSubmit.append("productName", formData.productName);
    formDataToSubmit.append("productPrice", formData.productPrice);
    formDataToSubmit.append("productUnitType", formData.productUnitType);
    formDataToSubmit.append("productAddress", formData.productAddress);
    formDataToSubmit.append("productPhone", formData.productPhone);
    formDataToSubmit.append("productEmail", formData.productEmail);
    formDataToSubmit.append("productStatus", formData.productStatus);
    formDataToSubmit.append("productType", formData.productType);
    formDataToSubmit.append("productDescription", formData.productDescription);
    formData.productImages.forEach((file, index) =>
      formDataToSubmit.append("productImages", file)
    );

    /**
     *
     * choosing URL whether to update or add product
     *
     */
    const MAIN_URL = productData._id
      ? `${BASE_URL}/api/bazar/updateProduct/${productData._id}`
      : `${BASE_URL}/api/bazar/addProduct`;

    try {
      let response = "";
      if (productData._id) {
        response = await axios.put(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        response = await axios.post(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (response.status === 201) {
        setBackEndError(<font color="green">Success TO ADD DATA.</font>);
        navigate("/market");
      } else if (response.status === 200) {
        setBackEndError(<font color="green">Success TO UPDATE DATA.</font>);
        navigate("/market");
      } else if (response.status === 401) {
        //alert or show error message
        setBackEndError(<font color="red">USER ALREADY EXISTS.</font>);
      } else if (response.status === 400) {
        //alert or show error message
        setBackEndError(<font color="red">ALL THE FIELDS ARE REQUIRED.</font>);
      } else if (response.status === 402) {
        //alert or show error message
        setBackEndError(<font color="red">INVALID USER DATA.</font>);
      }
    } catch (error) {
      const errorMessage = error.response.data.msg;
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{
              display: "grid",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="productName"
                label="Product Name"
                type="text"
                value={formData.productName}
                onChange={handleChange}
                error={Boolean(errors.productName)}
                helperText={errors.productName}
                fullWidth
                margin="normal"
                required
              />
              <FormControl
                style={{ flex: 3 }}
                margin="normal"
                error={Boolean(errors.productType)}
              >
                <InputLabel>Product Category</InputLabel>
                <Select
                  name="productType"
                  value={formData.productType}
                  onChange={handleChange}
                >
                  <MenuItem value="Vegetables">Vegetables</MenuItem>
                  <MenuItem value="Fruits">Fruits</MenuItem>
                  <MenuItem value="Animals">Animals</MenuItem>
                  <MenuItem value="Traditional Clothes">
                    Traditional Clothes
                  </MenuItem>
                  <MenuItem value="Handicrafts">Handicrafts</MenuItem>
                  <MenuItem value="Cooked Products">Cooked Products</MenuItem>
                  <MenuItem value="Meat & Fish">Meat & Fish</MenuItem>
                  <MenuItem value="Local Misc">Local Misc</MenuItem>
                </Select>
                {errors.productType && (
                  <FormHelperText>{errors.productType}</FormHelperText>
                )}
              </FormControl>
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="productPrice"
                label="Product Price"
                type="number"
                value={formData.productPrice}
                onChange={handleChange}
                error={Boolean(errors.productPrice)}
                helperText={errors.productPrice}
                fullWidth
                margin="normal"
                required
              />
              {/* Another TextField or empty space for 1/4 size */}
              <TextField
                style={{ flex: 3 }}
                name="productUnitType"
                label="Product Unit Type"
                type="text"
                value={formData.productUnitType}
                onChange={handleChange}
                error={Boolean(errors.productUnitType)}
                helperText={errors.productUnitType}
                fullWidth
                margin="normal"
                required
              />
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="productAddress"
                label="Address"
                type="text"
                value={formData.productAddress}
                onChange={handleChange}
                error={Boolean(errors.productAddress)}
                helperText={errors.productAddress}
                fullWidth
                margin="normal"
                required
              />

              <TextField
                style={{ flex: 3 }}
                name="productStatus"
                label="Product Status"
                type="text"
                defaultValue="Available"
                value={formData.productStatus}
                onChange={handleChange}
                error={Boolean(errors.productStatus)}
                helperText={errors.productStatus}
                fullWidth
                margin="normal"
                required
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="productEmail"
                label="Email"
                value={formData.productEmail}
                onChange={handleChange}
                error={Boolean(errors.productEmail)}
                helperText={errors.productEmail}
                fullWidth
                margin="normal"
                required
              />

              <TextField
                style={{ flex: 3 }}
                name="productPhone"
                label="Phone No"
                value={formData.productPhone}
                onChange={handleChange}
                error={Boolean(errors.productPhone)}
                helperText={errors.productPhone}
                type="number"
                fullWidth
                margin="normal"
                required
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 6 }}
                name="productDescription"
                label="Product Description"
                value={formData.productDescription}
                onChange={handleChange}
                multiline
                rows={4} // Number of rows for the text area
                fullWidth
                variant="outlined"
                error={Boolean(errors.productDescription)}
                helperText={errors.productDescription}
                margin="normal"
                required
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<UploadIcon />}
                style={{ margin: "10px 0" }}
              >
                Upload Images
                <input
                  id="productImages"
                  name="productImages"
                  type="file"
                  multiple
                  hidden
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Button>
            </div>
            {errors.productImages && (
              <span className="error-message">{errors.productImages}</span>
            )}
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {productImages.map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Preview ${index + 1}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />
              ))}
            </div>

            <span className="error-message">{backEndError}</span>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ borderRadius: "15px", width: "50%" }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" /> // Show loading spinner
              ) : (
                "Save"
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewMarket;
